<template>
  <v-dialog v-model="dialog" width="90%">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        style="margin-left:5px;font-size:8px; padding:0 2px;"
        color="white"
        dark
        elevation="1"
        class="black--text"
        small
        @click.stop="offer(value)"
        >Penawaran
      </v-btn>
    </template>
    <v-card style="padding:20px;" class="text-center">
      <v-row>
        <v-col cols="12" style="font-size:22px; font-weight:bold;">
          DETAIL PENAWARAN VENDOR
          <v-icon
            style="position:absolute; top:0; right:0; cursor:pointer;"
            @click="dialog = false"
            >mdi-close</v-icon
          >
        </v-col>
        <v-col
          cols="12"
          style="border:1px solid #e0e0e0; text-align:left; margin-bottom:10px;"
        >
          <DocNumber />
        </v-col>
        <v-col cols="12" style="border:1px solid #e0e0e0; margin-bottom:20px;">
          <v-data-table
            dense
            :headers="headers"
            :items="dataTable"
            class="elevation-1 mx-auto row-pointer"
            style="width:100%; margin-bottom:20px;"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @click:row="rowClick"
          >
          </v-data-table>
          <div class="pr-items-total-box">
            <div>
              <p>Sub Total <span>:</span></p>
              <p></p>
            </div>
            <div>
              <p>PPN 10% <span>:</span></p>
              <p></p>
            </div>
            <div>
              <p>Total <span>:</span></p>
              <p></p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <div>
      <Edit />
    </div>
  </v-dialog>
</template>
<script>
// import { mapActions, mapGetters, mapMutations } from 'vuex'
import DocNumber from './docNumber'
import Edit from '../modal/participant/QuotationDetailForm.vue'
export default {
  components: { DocNumber, Edit },
  props: ['value'],
  data() {
    return {
      dialog: false,
      dataTable: [],
      itemsPerPage: 10,
      headers: [
        {
          text: 'Kategori',
          value: 'category',
          align: 'left'
        },
        {
          text: 'Nama Barang',
          value: 'name',
          align: 'left'
        },
        {
          text: 'Spesifikasi',
          value: 'spesification',
          align: 'left'
        },
        {
          text: 'Harga Satuan',
          value: 'price_per_unit',
          align: 'left'
        },
        {
          text: 'Jumlah',
          value: 'amount',
          align: 'left'
        },
        {
          text: 'Satuan',
          value: 'unit',
          align: 'left'
        },
        {
          text: 'Total',
          value: 'total',
          align: 'left'
        }
      ],
      totalData: 1,
      options: {},
      loading: false
    }
  },
  computed: {},
  created() {
    this.initDataTable()
  },
  methods: {
    offer(val) {
      console.log(val)
    },

    initDataTable() {
      this.dataTable = [
        {
          category: 'Bahan Baku',
          name: 'BBK Polypropilene',
          spesification: 'Spek A',
          price_per_unit: 'Rp, 12',
          amount: '1,000,000',
          unit: 'Kg',
          total: '12,000,000    '
        }
      ]
    },
    rowClick(pValue) {
      document.getElementById('procQuotationDetailForm').click()
      // const doc = t
      // console.log(By)
    }
  }
}
</script>
<style lang="scss" scoped></style>
